import { Field, FieldArray, Formik } from "formik";
import React from "react";
import { Button, Col, Form, Label, Modal, Row } from "reactstrap";
import "../global/GlobalCSS.css";
import FormValuesDebug from "utils/debugTools/FormValuesDebug";
import apiGlobal from "global/api.global";
import { errorToast, successToast } from "Components/Toasts";
import { errResponse } from "GenericForms/Helper";
import { RootState } from "index";
import { useSelector } from "react-redux";

const CreateFleet = ({
    state,
    setState,
    invalidate,
}: {
    state: boolean;
    setState: any;
    invalidate: any;
}) => {
    /** State variables start */
    const { Vessels } = useSelector((state: RootState) => state.Reporting);
    const ApplicableVessels: any = Vessels.filter(
        (vessel: any) => vessel.display === true
    );
    /** State variables end */

    /** Open-close modal */
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_backdrop() {
        setState(!state);
        removeBodyCss();
    }

    /** Assign initail values to formik object of fleets */
    const getInitialVesselValue = () => {
        let arr: any[] = [];
        ApplicableVessels?.map((vessel: any) => {
            arr?.push({
                fleet_id: null,
                vessel_checkbox: false,
                vessel_id: vessel.id,
                vessel_name: vessel.vessel_name,
            });
            return "";
        });
        return arr;
    };

    /** Fleet's formik object */
    const FleetFormik = {
        initialValues: {
            fleet_name: "",
            vessels: getInitialVesselValue(),
        },
    };

    /** Vessel label onClick function */
    const handleVesselLabelChanges = (
        values: any,
        field: string,
        index: number,
        setFieldValue: any
    ) => {
        if (values[index]?.vessel_checkbox === false) {
            setFieldValue(field, true);
        } else {
            setFieldValue(field, false);
        }
    };

    return (
        <Modal
            size="lg"
            isOpen={state}
            toggle={() => {
                tog_backdrop();
            }}
            backdrop={"static"}
            id="staticBackdrop"
        >
            <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                    Create new fleet
                </h5>
                <button
                    onClick={() => {
                        setState(false);
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="minHeight15">
                    <Formik
                        initialValues={FleetFormik.initialValues}
                        onSubmit={(values: any, actions: any) => {
                            actions.setSubmitting(false);
                            const handleResponse = (response: any) => {
                                if (response.status === 201 || response.status === 200) {
                                    if (response.data.id > 0) {
                                        values?.vessels.map((vessel: any) => {
                                            return (vessel.fleet_id = response.data.id);
                                        });
                                        apiGlobal
                                            .post(`/fleet_vessel/`, values?.vessels)
                                            .then((res) => {
                                                if (res.status === 201) {
                                                    successToast("Data saved successfully!");
                                                    setState(false);
                                                    invalidate();
                                                }
                                            })
                                            .catch((err) => {
                                                if (errResponse.includes(err.response.status)) {
                                                    errorToast(
                                                        "Internal error occured, please contact the admin"
                                                    );
                                                }
                                            });
                                    }
                                }
                            };
                            // if (OtherDetailsObject && OtherDetailsObject.length > 0) {
                            //     try {
                            //         const res = apiGlobal.put(`/other_details/${values.id}/`, values);
                            //         handleResponse(res);
                            //     }
                            //     catch (err) {
                            //         console.log(err);
                            //     }
                            // } else {
                            apiGlobal
                                .post(`/fleet_master/`, values)
                                .then((res) => {
                                    handleResponse(res);
                                })
                                .catch((err) => {
                                    if (errResponse.includes(err.response.status)) {
                                        errorToast(
                                            "Internal error occured, please contact the admin"
                                        );
                                    }
                                });
                            // }
                        }}
                    >
                        {(props) => (
                            <Form onSubmit={props.handleSubmit} autoComplete="off" noValidate>
                                <Row className="mb-3">
                                    <Col lg={8}>
                                        <Label className="asteric mb-0">Fleet name</Label>
                                        <Field
                                            type="text"
                                            id="fleet_name"
                                            name="fleet_name"
                                            className="form-control"
                                        />
                                    </Col>
                                </Row>
                                <FieldArray name="vessels">
                                    {() => (
                                        <>
                                            {props?.values &&
                                                props?.values?.vessels?.map(
                                                    (vessel: any, index: number) => {
                                                        return (
                                                            <div key={index}>
                                                                <Row>
                                                                    <Col lg={6}>
                                                                        <div className="ele_row1">
                                                                            <Field
                                                                                type="checkbox"
                                                                                id="vessel_checkbox"
                                                                                name={`vessels.${index}.vessel_checkbox`}
                                                                                className="mr-1"
                                                                                onChange={(e: any) => {
                                                                                    props.handleChange(e);
                                                                                }}
                                                                            />
                                                                            <Label
                                                                                onClick={() =>
                                                                                    handleVesselLabelChanges(
                                                                                        props.values.vessels,
                                                                                        `vessels.${index}.vessel_checkbox`,
                                                                                        index,
                                                                                        props.setFieldValue
                                                                                    )
                                                                                }
                                                                            >
                                                                                {vessel.vessel_name}
                                                                            </Label>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                        </>
                                    )}
                                </FieldArray>
                                <Row>
                                    <Col>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            className="justify_right mt-3"
                                        >
                                            Save
                                        </Button>
                                    </Col>
                                </Row>
                                <FormValuesDebug values={[props.values, props.errors]} />
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
};

export default CreateFleet;
